import React from 'react';
import { Typography, Box } from '@mui/material';
import PageLayout from './PageLayout';

interface SuccessPageProps {
  nombreProveedor: string;
  fechaHora: string;
}

const SuccessPage: React.FC<SuccessPageProps> = ({ nombreProveedor, fechaHora }) => (
  <PageLayout maxWidth={520}>
    <Typography variant="h6" color="text.primary" sx={{ mb: 2 }}>
      Señor <Box component="span" sx={{ fontWeight: 700, color: 'primary.main' }}>{nombreProveedor}</Box>
    </Typography>
    <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
      Hemos recibido su cotización con éxito el día{' '}
      <Box component="span" sx={{ fontWeight: 700, color: 'primary.main' }}>{fechaHora}</Box>
    </Typography>
    <Typography variant="h6" color="success.main" sx={{ fontWeight: 600 }}>
      ¡Muchas gracias!
    </Typography>
  </PageLayout>
);

export default SuccessPage;
